
import React from 'react'
//import makeStyles from '@material-ui/core/styles/makeStyles'

export default function MedicalKitIcon(props) {
    const { style, color } = props;
    //const classes = useStyles(props)()

    return(
        <svg fill={color} style={style} width="23" height="23" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.555 4.172V1.192C6.555 0.535 7.09 0 7.747 0H14.897C15.555 0 16.089 0.535 16.089 1.191V4.171H20.856C21.844 4.171 22.644 4.971 22.644 5.958V8.057C22.644 8.775 22.213 9.424 21.551 9.703L12.711 13.425C11.823 13.799 10.823 13.799 9.936 13.425L1.095 9.704C0.433 9.425 0 8.775 0 8.058V5.959C0 4.972 0.801 4.172 1.788 4.172H6.555ZM8.938 4.172H13.705V2.384H8.938V4.172ZM15.493 22.645H7.151C3.86 22.645 1.192 19.978 1.192 16.686V12.453C1.192 12.159 1.431 11.919 1.725 11.919C1.797 11.919 1.869 11.935 1.935 11.963L9.689 15.266C10.732 15.71 11.912 15.71 12.956 15.266L20.71 11.963C20.98 11.847 21.294 11.973 21.409 12.243C21.438 12.309 21.451 12.381 21.451 12.453V16.686C21.453 19.978 18.785 22.645 15.493 22.645Z"/>
        </svg>

    )
}

/*const useStyles = props => makeStyles((theme) => ({
    
}));*/